<template>
    <b-dropdown-text>
        <slot />
    </b-dropdown-text>
</template>

<script>
import { BDropdownText } from 'bootstrap-vue'

export default {
    components: { BDropdownText },
}
</script>